import { AgGridService } from "@topline/services/agGridService";
import { angularServicesNames } from "@topline/services/angularServicesNames";

(module => {
    module.component('rotationAndStock', {
        template: require('./rotationAndStockComponent.html'),
        bindings: {
            skus: "=",
            parameters: '<',
            isEditable: '<'
        },
        controller: ['$scope', angularServicesNames.$translate, AgGridService.componentName, 'vmiDataProvider',
            function(
                this: $TSFixMe,
                $scope: $TSFixMe,
                $translate: ng.translate.ITranslateService,
                agGridService: AgGridService,
                vmiDataProvider: $TSFixMe
            ) {
                var $ctrl = this;

                $ctrl.$onInit = () => {
                    $scope.$watch('$ctrl.skus', () => refreshGrid());
                }

                
                const dateFormatter = (params: $TSFixMe) => params.value ? moment.utc(params.value).format('YYYY-MM-DD') : '';

                $scope.$on('LanguageChanged', () => agGridService.refreshGridLanguage($ctrl.gridApi));

                $ctrl.rotationAndStockGridOptions = {
                    columnDefs: [
                        {
                            headerValueGetter: () => $translate.instant("FORECAST.ROTATION_AND_STOCK.ORACLE_INDEX"), field: "oracleIndex"
                        },
                        {
                            headerValueGetter: () => $translate.instant("FORECAST.ROTATION_AND_STOCK.SKU"), field: "name"
                        },
                        {
                            field: 'forecast.exFactory.salesFrom',
                            headerValueGetter: () => $translate.instant('FORECAST.ROTATION_AND_STOCK.SALES_FROM'),
                            valueFormatter: dateFormatter
                        },
                        {
                            field: 'forecast.exFactory.salesTo',
                            headerValueGetter: () => $translate.instant('FORECAST.ROTATION_AND_STOCK.SALES_TO'),
                            valueFormatter: dateFormatter
                        },
                        {
                            field: 'forecast.exFactory.sales',
                            headerValueGetter: () => $translate.instant('FORECAST.ROTATION_AND_STOCK.SALES'),
                            valueFormatter: () => "{{ data.forecast.exFactory.sales | number : 0 }}"
                        },
                        {
                            field: 'forecast.exFactory.itemsInStock',
                            headerValueGetter: () => $translate.instant('FORECAST.ROTATION_AND_STOCK.STOCK'),
                            cellRenderer: () => `{{ data.forecast.exFactory.itemsInStock | number : 0 }}
                            <i class="glyphicon glyphicon-pencil" ng-if='$ctrl.isEditable && !data.forecast.exFactory.originalItemsInStock'></i>`,
                            editable: (params: $TSFixMe) => $ctrl.isEditable && !params.data.forecast.exFactory.originalItemsInStock,
                            valueSetter: (params: $TSFixMe) => {
                                if (isNaN(parseInt(params.newValue)) || !isFinite(params.newValue)) {
                                    return false; // don't set invalid numbers!
                                }
                                params.data.forecast.exFactory.itemsInStock = parseInt(params.newValue);
                                return true;
                            }
                        },
                        {
                            field: 'forecast.exFactory.itemsInStockDate',
                            headerValueGetter: () => $translate.instant('FORECAST.ROTATION_AND_STOCK.STOCK_DATE'),
                            valueFormatter: dateFormatter
                        },
                        {
                            field: 'forecast.exFactory.originalRotation',
                            headerValueGetter: () => $translate.instant('FORECAST.ROTATION_AND_STOCK.ORIGINAL_ROTATION'),
                            valueFormatter: () => "{{ data.forecast.exFactory.originalRotation | number : 2 }}"
                        },
                        {
                            field: 'forecast.exFactory.rotation', editable: true,
                            headerValueGetter: () => $translate.instant('FORECAST.ROTATION_AND_STOCK.ROTATION'),
                            cellRenderer: () =>
                                `{{ data.forecast.exFactory.rotation | number : 2 }}  
                            <i class="glyphicon glyphicon-pencil" ng-if="$ctrl.isEditable" ng-click="$ctrl.editRotation(rowNode)"></i>
                            <i class='fas fa-undo' title="{{ 'FORECAST.ROTATION_AND_STOCK.RESTORE_ROTATION' | translate }}"
                                ng-if='$ctrl.isEditable && data.forecast.exFactory.rotation != data.forecast.exFactory.originalRotation' 
                                ng-click='$ctrl.undoRotation(data)' ></i>`,
                            // @ts-expect-error ts-migrate(1117) FIXME: An object literal cannot have multiple properties ... Remove this comment to see the full error message
                            editable: () => $ctrl.isEditable,
                            valueSetter: (params: $TSFixMe) => {
                                if (isNaN(parseFloat(params.newValue)) || !isFinite(params.newValue)) {
                                    return false; // don't set invalid numbers!
                                }
                                params.data.forecast.exFactory.rotation = parseFloat(params.newValue);
                                return true;
                            }
                        },
                        {
                            field: 'forecast.exFactory.launchDate',
                            headerValueGetter: () => $translate.instant('FORECAST.ROTATION_AND_STOCK.LAUNCH_DATE'),
                            cellRenderer: () =>
                                `{{ data.forecast.exFactory.launchDate | date : 'yyyy-MM' }}
                                <i class="glyphicon glyphicon-calendar" ng-click="popup1.opened = true"></i>
                                <input name="launchDate" type="text" uib-datepicker-popup="MM-yyyy" ng-model="data.forecast.exFactory.launchDate" 
                                        datepicker-append-to-body="true"
                                        is-open="popup1.opened" ng-model-options="{ timezone  : 'UTC'}" 
                                        datepicker-options="{minMode: 'month'}"
                                        current-text="{{'TODAY' | translate}}" close-text="{{'CLOSE' | translate}}" clear-text="{{'CLEAR' | translate}}"
                                        ng-readonly="true" class="invisible"
                                    />
                                `,
                            editable: () => false
                        },
                    ],
                    angularCompileRows: true,
                    animateRows: true,
                    defaultColDef: {
                        sortable: true,
                        resizable: true
                    },
                    suppressMultiSort: true,
                    domLayout: 'autoHeight',
                    pagination: true,
                    paginationPageSize: 10,
                    localeTextFunc: agGridService.transalteFunc,
                    suppressHorizontalScroll: true,
                    suppressDragLeaveHidesColumns: true,
                    onCellEditingStopped: function (event: $TSFixMe) {
                        $ctrl.gridApi.redrawRows({ rowNodes: [event.node] });
                    },
                    onGridReady: (config: $TSFixMe) => {
                        $ctrl.gridApi = config.api;
                        config.api.sizeColumnsToFit();
                        refreshGrid();
                    },
                    onGridSizeChanged: (config: $TSFixMe) => {
                        config.api.sizeColumnsToFit();
                    }
                }

                $ctrl.undoRotation = (data: $TSFixMe) => {
                    data.forecast.exFactory.rotation = data.forecast.exFactory.originalRotation;
                }

                $ctrl.editRotation = (rowNode: $TSFixMe) => {
                    $ctrl.gridApi.startEditingCell({
                        rowIndex: rowNode.rowIndex,
                        colKey: 'forecast.exFactory.rotation'
                    });
                }

                $ctrl.reloadRotation = () => {
                    const oracleIndexes = $ctrl.skus.map((s: $TSFixMe) => s.oracleIndex);
                    $ctrl.reloadRotationOperation = vmiDataProvider.getRotationInfo($ctrl.parameters.forecastStartDate, oracleIndexes).then((data: $TSFixMe) => {
                        for (const sku of $ctrl.skus) {
                            const vmiData = data[sku.oracleIndex];
                            sku.forecast.exFactory.sales = vmiData.sales;
                            sku.forecast.exFactory.salesTo = vmiData.salesTo;
                            sku.forecast.exFactory.salesFrom = vmiData.salesFrom;
                            sku.forecast.exFactory.originalRotation = sku.forecast.exFactory.rotation = vmiData.rotation;
                            sku.forecast.exFactory.itemsInStock = sku.forecast.exFactory.originalItemsInStock = vmiData.itemsInStock;
                            sku.forecast.exFactory.itemsInStockDate = vmiData.itemsInStockDate;
                            sku.forecast.exFactory.launchDate = vmiData.exFactory.launchDate;
                        }
                    });
                }

                function refreshGrid() {
                    if ($ctrl.gridApi) {
                        $ctrl.gridApi.setRowData($ctrl.skus ? $ctrl.skus : []);
                    }
                }
            }]
    });

})(angular.module('topline.modules'));